// extracted by mini-css-extract-plugin
export default {"MainCont":"Packaging_MainCont__fUUqg","RightCont":"Packaging_RightCont__A+iq6"};